// extracted by mini-css-extract-plugin
export default {"base":"Error_base__p0oQ-","isSmall":"Error_isSmall__mQH2b"};